<template>
  <div>
    <div class="report-loader text-center mb-5" v-if="loading">
      <img src="/images/loading.gif" />
    </div>

    <div v-else>
      <div class="justify-content-center mb-5">
        <div
          class="file-selection-bar consulting-bar mb-0"
          style="clear: left"
          v-bind:class="
            (consulting_slug !== 'customized-report' &&
              report.live_report_id !== '' &&
              report.live_report_id !== '0' &&
              report.live_report_id !== null) ||
            selected === live_id
              ? 'file-selection-bar_three-col'
              : 'file-selection-bar_two-col'
          "
        >
          <div class="report-title">
            <form class="noFlex" v-on:change="selectReport(selected)">
              <select
                name="report-date"
                id="report-date"
                v-model="selected"
                :disabled="disabled ? true : false"
              >
                <option v-if="live_id > 0" :value="Number(live_id)">
                  Real-Time Charting
                </option>
                <template v-for="report in reports" :key="report.id">
                  <option :value="report.id">
                    {{ momentFormat(report.issue, 'MMMM YYYY') }}
                  </option>
                </template>
              </select>
            </form>
          </div>

          <div class="report-files">
            <template v-if="consulting_slug === 'customized-report'">
              <a
                id="customized-report-link"
                href=""
                title="Download PDF"
                download
              >
                <img
                  :src="'/images/icons/icon-pdf.svg'"
                  alt="File"
                  title="Download PDF"
                />
              </a>
            </template>
            <template v-else-if="report.downloads.pdf">
              <a
                :href="'/storage/' + report.downloads.pdf"
                title="Download PDF"
              >
                <img
                  :src="'/images/icons/icon-pdf.svg'"
                  alt="File"
                  title="Download PDF"
                />
              </a>
            </template>
            <template
              v-else-if="
                (report.live_report_id !== '' &&
                  report.live_report_id !== '0' &&
                  report.live_report_id !== null) ||
                selected === live_id
              "
            >
              <template
                v-if="
                  consulting_slug === 'evp-series' && report_add_ons !== '1'
                "
              >
                <div id="downloadPDFLoader">
                  <img src="/images/loading.gif" />
                </div>
                <a
                  class="vue-anchor"
                  id="downloadPDFButton"
                  v-on:click="downloadPDF()"
                  title="Download PDF"
                  style="display: none"
                >
                  <img
                    :src="'/images/icons/icon-pdf.svg'"
                    alt="File"
                    title="Download PDF"
                  />
                </a>
              </template>
              <template v-else>
                <a
                  class="vue-anchor"
                  id="downloadPDFButton"
                  v-on:click="downloadPDF()"
                  title="Download PDF"
                >
                  <img
                    :src="'/images/icons/icon-pdf.svg'"
                    alt="File"
                    title="Download PDF"
                  />
                </a>
              </template>
            </template>

            <template v-if="report.downloads.xls">
              <a
                :href="'/storage/' + report.downloads.xls"
                title="Download Excel"
              >
                <img
                  :src="'/images/icons/icon-xls.svg'"
                  alt="File"
                  title="Download Excel"
                />
              </a>
            </template>
            <template
              v-else-if="
                (consulting_slug !== 'dashboard' &&
                  consulting_slug !== 'customized-report' &&
                  report.live_report_id !== '' &&
                  report.live_report_id !== '0' &&
                  report.live_report_id !== null) ||
                selected === live_id
              "
            >
              <a
                class="vue-anchor"
                v-on:click="downloadExcel()"
                title="Download Excel"
              >
                <img
                  :src="'/images/icons/icon-xls.svg'"
                  alt="File"
                  title="Download Excel"
                />
              </a>
            </template>

            <template v-if="report.downloads.vimeo">
              <a
                class="vue-anchor"
                :href="'/consulting/vimeo-video/' + report.downloads.vimeo"
                target="_blank"
                title="Redirect to video"
              >
                <img
                  :src="'/images/icons/icon-mov.svg'"
                  alt="File"
                  title="Redirect to video"
                />
              </a>
            </template>

            <template v-if="report.downloads.ppt">
              <a
                :href="'/storage/' + report.downloads.ppt"
                title="Download Power Point"
              >
                <img
                  :src="'/images/icons/icon-ppt.svg'"
                  alt="File"
                  title="Download Power Point"
                />
              </a>
            </template>
            <template
              v-else-if="
                (consulting_slug !== 'dashboard' &&
                  consulting_slug !== 'customized-report' &&
                  report.live_report_id !== '' &&
                  report.live_report_id !== '0' &&
                  report.live_report_id !== null) ||
                selected === live_id
              "
            >
              <template
                v-if="
                  consulting_slug === 'evp-series' && report_add_ons !== '1'
                "
              >
                <div id="downloadPPTLoader">
                  <img src="/images/loading.gif" />
                </div>
                <a
                  class="vue-anchor"
                  id="downloadPPTButton"
                  v-on:click="downloadPPT()"
                  title="Download Power Point"
                  style="display: none"
                >
                  <img
                    :src="'/images/icons/icon-ppt.svg'"
                    alt="File"
                    title="Download Power Point"
                  />
                </a>
              </template>
              <template v-else>
                <a
                  class="vue-anchor"
                  id="downloadPPTButton"
                  v-on:click="downloadPPT()"
                  title="Download Power Point"
                >
                  <img
                    :src="'/images/icons/icon-ppt.svg'"
                    alt="File"
                    title="Download Power Point"
                  />
                </a>
              </template>
            </template>
          </div>

          <template
            v-if="
              (consulting_slug !== 'customized-report' &&
                report.live_report_id !== '' &&
                report.live_report_id !== '0' &&
                report.live_report_id !== null) ||
              selected === live_id
            "
          >
            <!--live report navigation bar-->
            <div class="report-title second-title" style="border-bottom: none">
              <select
                name="report-page"
                id="report-page"
                v-on:input="selectPage($event)"
              ></select>
            </div>
          </template>
        </div>
        <!-- real time charting message -->
        <p
          id="realTimeChartingNote"
          class="small hide px-3 text-medium-left text-small-center"
        >
          Real-Time Charting is enabled – the charts are updated with the latest
          data. All other on-page content was produced specifically for the
          previous report delivery and may no longer be applicable.
        </p>
        <!-- Published date for non real time reports -->
        <!-- CCB417 remove this for consulting only  -->
        <!-- <div class="row">
                    <div class="col">
                        <p id="published-date" class="small px-1 text-medium-left text-small-center report-upload-date-consulting">
                            Published {{ report.update_date }}
                        </p>
                    </div>
                </div> -->
      </div>
      <div class="report-loader text-center mb-5" v-if="loadingPageArea">
        <img src="/images/loading.gif" />
      </div>
      <div v-else class="pb-5">
        <template
          v-if="
            consulting_slug === 'customized-report' &&
            report.live_report_id !== '' &&
            report.live_report_id !== '0' &&
            report.live_report_id !== null
          "
        >
          <CustomizedReportComponent
            :app_url="app_url"
            :reportID="selected"
            :apiID="report.live_report_id"
            @toggleDisabledBit="toggleDisabledBit"
          />
        </template>
        <template
          v-else-if="
            (report.live_report_id !== '' &&
              report.live_report_id !== '0' &&
              report.live_report_id !== null) ||
            selected === live_id
          "
        >
          <LiveReportParentComponent
            ref="live_report_parent"
            :live_id="live_id"
            :report_id="report.live_report_id"
            :ondemand_report_id="report.id"
            :consulting_slug="consulting_slug"
            :reportAddOns="report_add_ons"
            :report360="report_360"
            :reportTypeId="report_type_to_view"
            @toggleDisabledBit="toggleDisabledBit"
          />

          <!-- pagination -->
          <div class="row">
            <div class="col text-center">
              <button
                title="Previous Page"
                class="mr-3 pageNav"
                v-on:click="pushToPreviousPage()"
              >
                <img src="/images/carat-l-white.png" />
              </button>
              <span id="paginationPagesLabel">0/0</span>
              <button
                title="Next Page"
                class="ml-3 pageNav"
                v-on:click="pushToNextPage()"
              >
                <img src="/images/carat-r-white.png" />
              </button>
            </div>
          </div>

          <!-- modal for downloading -->
          <div
            class="modal fade"
            id="loadingFileModal"
            tabindex="-1"
            role="dialog"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                  >
                    &times;
                  </button>
                </div>
                <div class="modal-body" style="min-height: auto !important">
                  <p>Loading file. Please wait.</p>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div v-else>
          <!-- Not a live report, load PDF -->
          <div>
            <template v-if="!safarimobile">
              <div class="iframeEmbed insiderIframe--wrapper" id="google">
                <iframe
                  class="insiderIframe"
                  :src="'/storage/' + report.downloads.pdf"
                ></iframe>
              </div>
            </template>
            <template v-else>
              <!--use the google renderer-->
              <!-- <p><a :href="'/storage/' + report.downloads.pdf" class="button-green">Download PDF</a></p> -->
              <!-- <div class="iframeEmbed insiderIframe--wrapper" id="google">
                                <iframe :src="'https://docs.google.com/viewer?url='+ app_url+ '/storage/' + report.downloads.pdf+'&embedded=true'" style="width:100%; height:100%;" frameborder="0"></iframe>
                            </div> -->
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import moment from 'moment';
  import LiveReportParentComponent from '~/components/report/modules/live-report/LiveReportParentComponent.vue';
  import CustomizedReportComponent from '~/components/report/modules/live-report/customized-report/CustomizedReportComponent.vue';

  export default {
    name: 'ReportByIDComponent',
    components: {
      LiveReportParentComponent,
      CustomizedReportComponent,
    },
    props: {
      report_type_to_view: {
        type: [Number, String],
        required: true,
      },
      app_url: {
        type: String,
        required: true,
      },
      live_id: {
        type: [Number, String],
        required: true,
      },
      report_type_id: {
        type: [Number, String],
        required: true,
      },
      consulting_slug: {
        type: String,
        required: true,
      },
      report_add_ons: {
        type: [Boolean, String],
        default: false,
      },
      report_360: {
        type: [Boolean, String],
        default: false,
      },
    },
    data: () => ({
      loading: true,
      loadingPageArea: true,
      reports: [],
      selected: '',
      report: {
        id: '',
        name: '',
        data_file: '',
        downloads: {
          doc: '',
          xls: '',
          pdf: '',
          ppt: '',
        },
        iframe: '',
        live_report_id: '',
        companyLogo: '',
        update_date: '',
      },
      safarimobile:
        navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
        navigator.userAgent.match(/AppleWebKit/),
      error_message: true,
      datacollection: null,
      is_downloading_pdf: false,
      disabled: true,
    }),
    mounted() {
      this.getReports();
    },
    methods: {
      momentFormat(date, format) {
        return moment(date).format(format);
      },
      //Inital get reports
      getReports: function () {
        axios
          .get('/reports/by_report_type_id/' + this.report_type_to_view)
          .then((success) => {
            this.reports = success.data.data;
            this.loading = false;

            if (this.reports.length) {
              this.selected = success.data.data[0].id;
              this.selectReport(success.data.data[0].id);
            }
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      //select report
      selectReport: function (id) {
        // disable dropdown while data loads
        this.disabled = true;
        //show loading page area while pdf/api loads
        this.loadingPageArea = true;

        //reset report
        // this.report = {
        // 	id: '',
        // 	name: '',
        // 	data_file: '',
        // 	downloads: {
        // 		doc: '',
        // 		xls: '',
        //         pdf: '',
        //         ppt: '',
        // 	},
        // 	iframe: '',
        // 	//live_id: '',
        // 	live_report_id: '',
        // 	//report_type_live_id:this.live_id
        //     update_date: ''
        // }

        if (
          this.consulting_slug === 'evp-series' &&
          this.report_add_ons !== '1'
        ) {
          $('#downloadPDFButton').hide();
          $('#downloadPPTButton').hide();

          $('#downloadPDFLoader').show();
          $('#downloadPPTLoader').show();
        }

        //hide real time charting message
        $('#realTimeChartingNote').addClass('hide');

        //hide published note
        $('#published-date').addClass('hide');

        // check if id passed is live ID
        if (id == this.live_id) {
          // this.selected = Number(id);
          $('#realTimeChartingNote').removeClass('hide');

          this.report.live_report_id = Number(id);
          this.loadingPageArea = false;
        } else {
          $('#published-date').removeClass('hide');
          let r = this.reports.find((obj) => obj.id == id);
          if (r) {
            this.report = {
              id: r.id,
              name: r.pdf_file_name,
              data_file: r.data_attachment,
              downloads: {
                doc: r.doc_attachment,
                xls: r.xls_attachment,
                pdf: r.pdf_attachment,
                ppt: r.ppt_attachment,
                vimeo: r.vimeo_id,
              },
              iframe: '',
              live_report_id: r.live_report_id,
              update_date: moment(r.updated_at).format('MMMM DD, YYYY'),
            };

            this.loadingPageArea = false;
          }
        }

        // no report ID found - remove disable now bc it's PDF
        if (!this.report.live_report_id) {
          this.disabled = false;
        }
      },
      selectPage: function (event) {
        if (event) {
          // this.selectedPage = event.target.value;
          let pageIndex =
            event.target[event.target.selectedIndex].getAttribute('index') ?? 0;

          this.$refs.live_report_parent.updateSlug(
            event.target.value,
            pageIndex
          );
          document.getElementById('paginationPagesLabel').innerHTML =
            event.target.selectedIndex + 1 + '/' + event.target.length;
        } else {
          var page = document.getElementById('report-page');
          // this.selectedPage = page.value;
          let pageIndex = page[page.selectedIndex].getAttribute('index') ?? 0;
          this.$refs.live_report_parent.updateSlug(page.value, pageIndex);
          document.getElementById('paginationPagesLabel').innerHTML =
            page.selectedIndex + 1 + '/' + page.length;
        }
      },
      pushToNextPage: function () {
        var page = document.getElementById('report-page');
        if (page.selectedIndex < page.length - 1) page.selectedIndex++;

        this.selectPage();
      },
      pushToPreviousPage: function () {
        // $('#report-page option:selected').prev().attr('selected', 'selected');
        var page = document.getElementById('report-page');
        if (page.selectedIndex >= 1) page.selectedIndex--;

        this.selectPage();
      },
      downloadExcel: function () {
        $('#loadingFileModal').modal('show');
        let url = '';

        //request data and build on backend
        if (this.consulting_slug === 'timing-model') {
          // url = '/consulting/build-timing-model-excel/';
          if (this.live_id == this.report.live_report_id) {
            url = '/consulting/build-timing-model-excel/0/' + this.live_id;
          } else {
            url =
              '/consulting/build-timing-model-excel/' +
              this.report.live_report_id +
              '/0';
          }
        } else {
          // url = '/consulting/build-evp-excel/';
          if (this.live_id == this.report.live_report_id) {
            url = '/consulting/build-evp-excel/0/' + this.live_id;
          } else {
            url =
              '/consulting/build-evp-excel/' +
              this.report.live_report_id +
              '/0';
          }
        }

        if (url !== '') {
          axios
            .get(url, { responseType: 'arraybuffer' })
            .then((success) => {
              var fileURL = window.URL.createObjectURL(
                new Blob([success.data])
              );
              var fileLink = document.createElement('a');
              fileLink.id = 'excel_' + this.report.live_report_id;
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'data-export.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              fileLink.remove();
              $('#loadingFileModal').modal('hide');
            })
            .catch(function (error) {
              // TODO: HANDLE ERROR - This is just silencing the error
            });
        } else {
          alert('Error downloading excel file. Please contact support.');
        }
      },
      downloadPDF() {
        $('#loadingFileModal').modal('show');
        this.$refs.live_report_parent.downloadPDF();
        //https://codimth.com/blog/web/vuejs/vue-laravel-how-properly-exportdownload-generated-pdf-or-excel-files
      },
      downloadPPT() {
        $('#loadingFileModal').modal('show');
        // PpTxGenJS Documentation https://gitbrent.github.io/PptxGenJS/
        this.$refs.live_report_parent.downloadPPT();
      },
      //helpers
      //format filename to remove .pdf
      fixFileName: function (filename) {
        return filename.replace('.pdf', '');
      },
      toggleDisabledBit: function () {
        this.disabled = false;
      },
    },
  };
</script>
<style>
  select#report-page {
    border-radius: 10px;
  }
  .pageNav {
    background: #a7a9ab;
    padding: 10px 15px 10px 15px;
    border-radius: 2em;
    cursor: pointer;
  }

  @media only screen and (max-width: 799px) {
    .second-title {
      border-top: 1px solid #dbdcde;
    }
  }
</style>
